import * as React from "react";
import "./index.css";

export function NotFoundPage() {
    return (
        <article className="notfd">
            <section className="notfd-cont">
                <h1 className="notfd-title">404</h1>
                <p className="notfd-description">Page not found</p>
            </section>
        </article>
    );
}
